import { Component, type ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

/**
 * Isolates auth-banner animation failures so they cannot take down `/login`
 * via the app-wide or React Router error boundaries.
 */
class AuthMarketingLottieBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default AuthMarketingLottieBoundary;
